import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { DeezerLinkComponent } from './deezer-link.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-album-grid',
  imports: [RouterLink, MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle, MatChip, MatIcon, DeezerLinkComponent],
  templateUrl: './album-grid.component.html',
  styleUrls: ['./album-grid.component.css']
})
export class AlbumGridComponent {
  albums = input.required<any[]>();
  subtitle = input('Top Album');
  /** Saved album ids; when given, each card shows a heart that toggles the favourite. */
  favouriteIds = input<ReadonlySet<string> | null>(null);
  favouriteToggle = output<any>();
}
